<template>
	<div class="chat-container">
		<!-- Заголовок чата -->
		<div class="chat-header">
			<div class="teacher-info">
				<h3 class="teacher-name">Мария Ивановна Седакова</h3>
				<p class="teacher-role">Преподаватель</p>
			</div>
		</div>

		<!-- Область сообщений -->
		<div class="chat-messages">
			<div class="messages-wrapper">
				<!-- Даты сообщений -->
				<div class="data-message"><p class="data-text">1 Октября</p></div>

				<!-- Сообщения преподавателя (слева) -->
				<div class="teacher-messages">
					<!-- Сообщение 1 -->
					<div class="message message-teacher">
						<div class="message-content">
							<p class="message-text">
								Здравствуйте, Анна<br />
								Как продвигается выполнение задания по настройке инфоблоков?
							</p>
							<span class="message-time">12:23</span>
						</div>
					</div>

					<!-- Сообщение 2 -->
					<div class="message message-teacher tech-mid">
						<div class="message-content">
							<p class="message-text">Напоминаю, срок сдачи — до среды</p>
							<span class="message-time">12:23</span>
						</div>
					</div>

					<!-- Сообщение 3 -->
					<div class="message message-teacher teach-small">
						<div class="message-content">
							<p class="message-text">Хорошо, жду</p>
							<span class="message-time">12:24</span>
						</div>
					</div>
				</div>

				<!-- Сообщения студента (справа) -->
				<div class="student-messages">
					<!-- Сообщение 1 -->
					<div class="message message-student stud-small">
						<div class="message-content">
							<p class="message-text">Здравствуйте</p>
							<div class="message-meta">
								<div class="message-status">
									<svg class="status-icon" viewBox="0 0 16 12" fill="none">
										<path
											d="M1 6L5 10L15 1"
											stroke="currentColor"
											stroke-width="2"
										/>
										<path
											d="M7 6L11 10L19 1"
											stroke="currentColor"
											stroke-width="2"
										/>
									</svg>
								</div>
								<span class="message-time">12:23</span>
							</div>
						</div>
					</div>

					<!-- Сообщение 2 -->
					<div class="message message-student stud-big">
						<div class="message-content">
							<p class="message-text">
								Всё в процессе, спасибо, что напомнили. Как раз заканчиваю
							</p>
							<div class="message-meta">
								<div class="message-status">
									<svg class="status-icon" viewBox="0 0 14 12" fill="none">
										<path
											d="M1 6L5 10L15 1"
											stroke="currentColor"
											stroke-width="2"
										/>
										<path
											d="M7 6L11 10L19 1"
											stroke="currentColor"
											stroke-width="2"
										/>
									</svg>
								</div>
								<span class="message-time">12:23</span>
							</div>
						</div>
					</div>

					<!-- Сообщение 3 -->
					<div class="message message-student stud-small-1">
						<div class="message-content">
							<p class="message-text">Отправила</p>
							<div class="message-meta">
								<div class="message-status message-status-sent">
									<svg class="status-icon" viewBox="0 0 16 12" fill="none">
										<path
											d="M1 6L5 10L15 1"
											stroke="currentColor"
											stroke-width="3"
										/>
									</svg>
								</div>
								<span class="message-time">13:05</span>
							</div>
						</div>
					</div>
				</div>

				<!-- Даты сообщений -->
				<div class="data-message"><p class="data-text">2 Октября</p></div>

				<!-- Сообщения студента (справа) -->
				<div class="student-messages">
					<!-- Сообщение 3 -->
					<div class="message message-student stud-big">
						<div class="message-content">
							<p class="message-text">
								Здравствуйте! Подскажите, пожалуйста, когда будет открыт
								следующий тест в первом модуле?
							</p>
							<div class="message-meta">
								<div class="message-status message-status-sent">
									<svg class="status-icon" viewBox="0 0 16 12" fill="none">
										<path
											d="M1 6L5 10L15 1"
											stroke="currentColor"
											stroke-width="3"
										/>
									</svg>
								</div>
								<span class="message-time">09:15</span>
							</div>
						</div>
					</div>

					<!-- Сообщение 3 -->
					<div class="message message-student stud-big">
						<div class="message-content">
							<p class="message-text">
								Я хочу уложиться в общие сроки сдачи курса и планирую свою
								нагрузку.
							</p>
							<div class="message-meta">
								<div class="message-status message-status-sent">
									<svg class="status-icon" viewBox="0 0 16 12" fill="none">
										<path
											d="M1 6L5 10L15 1"
											stroke="currentColor"
											stroke-width="3"
										/>
									</svg>
								</div>
								<span class="message-time">09:17</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Поле ввода с отдельной кнопкой -->
		<div class="chat-input-wrapper_sms">
			<div class="chat-input">
				<input
					type="text"
					class="chat-input-field"
					placeholder="Сообщение"
					v-model="messageText"
					@keydown.enter="sendMessage"
				/>
			</div>

			<button class="send-button" @click="sendMessage">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="25"
					height="25"
					viewBox="-2 0 25 25"
					fill="none"
				>
					<path
						d="M21.66,12a2,2,0,0,1-1.14,1.81L5.87,20.75A2.08,2.08,0,0,1,5,21a2,2,0,0,1-1.82-2.82L5.46,13H11a1,1,0,0,0,0-2H5.46L3.18,5.87A2,2,0,0,1,5.86,3.25h0l14.65,6.94A2,2,0,0,1,21.66,12Z"
						fill="currentColor"
					/>
				</svg>
			</button>
		</div>
	</div>
</template>

<script>
import { ref } from 'vue'

export default {
	name: 'ChatComponent',
	setup() {
		const messageText = ref('')

		const sendMessage = () => {
			if (messageText.value.trim()) {
				console.log('Отправка сообщения:', messageText.value)
				// Здесь логика отправки сообщения
				messageText.value = ''
			}
		}

		return {
			messageText,
			sendMessage,
		}
	},
}
</script>

<style scoped>
/* Контейнер чата */
.chat-container {
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 530px;
	height: 100%;
	max-height: 650px;
	background: url('~@/../public/assets/animaapp/---.png') center/cover;
	border-radius: 0px 12px 12px 12px;
	overflow: hidden;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Заголовок */
.chat-header {
	background: rgba(65, 139, 152, 0.8);
	backdrop-filter: blur(10px);
	padding: 12px 20px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.teacher-info {
	text-align: center;
}

.teacher-name {
	margin: 0;
	color: rgba(255, 255, 255, 0.9);
	font-family: 'Poppins', sans-serif;
	font-size: 14px;
	font-weight: 600;
	letter-spacing: 0.3px;
}

.teacher-role {
	margin: 2px 0 0 0;
	color: rgba(255, 255, 255, 0.7);
	font-family: 'Poppins', sans-serif;
	font-size: 11px;
	font-weight: 500;
}

/* Область сообщений */
.chat-messages {
	min-height: 0;
	flex: 1;
	display: flex;
	flex-direction: column;
	background: transparent;
	overflow-y: auto;
}

.messages-wrapper {
	flex-direction: column;
	/* flex: 1; */
	padding: 20px;
	display: flex;
	gap: 12px;
	overflow-y: auto;
}

/* Стили для скроллбара */
.messages-wrapper::-webkit-scrollbar {
	width: 6px;
}

.messages-wrapper::-webkit-scrollbar-track {
	background: transparent;
}

.messages-wrapper::-webkit-scrollbar-thumb {
	background: rgba(0, 0, 0, 0.2);
	border-radius: 3px;
}

/* Колонки сообщений */
.teacher-messages,
.student-messages {
	display: flex;
	flex-direction: column;
	gap: 5px;
	flex: 1;
}

.student-messages {
	align-items: flex-end;
}

/* Базовый стиль сообщения */
.message {
	/*max-width: 55%;*/
	animation: fadeIn 0.3s ease;
}

.data-message {
	background: rgba(84, 84, 84, 0.4);
	backdrop-filter: blur(5px);
	border-radius: 20px 20px 20px 20px;
	min-height: 30px;
	max-width: 150px;
	margin-left: 190px;

	/* Центрирование текста */
	display: flex;
	align-items: center;
	justify-content: center;
}
.data-text {
	margin: 0;
	color: rgba(255, 255, 255);
	font-family: 'Poppins', sans-serif;
	font-size: 13px;
	font-weight: 700;
	line-height: 1.5;
	word-wrap: break-word;
	text-align: center;
}

@keyframes fadeIn {
	from {
		opacity: 0;
		transform: translateY(10px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.message-content {
	position: relative;
	padding: 8px 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.teach-small {
	max-width: 45%;
	margin-top: 180px;
}

.tech-mid {
	max-width: 75%;
}

/* Сообщения преподавателя */
.message-teacher .message-content {
	background: rgba(157, 204, 255, 0.5);
	backdrop-filter: blur(5px);
	border-radius: 20px 20px 20px 5px;
	min-height: 30px; /* выше плашка */
	max-width: 50%;
}

.stud-small {
	margin-top: -235px;
}
.stud-small-1 {
	margin-top: 80px;
}

.stud-big {
	/*margin-top: -80px;*/
	max-width: 50%;
}

/* Сообщения студента */
.message-student .message-content {
	background: rgba(255, 255, 255, 0.4);
	backdrop-filter: blur(5px);
	border-radius: 20px 20px 4px 20px;
}

/* Текст сообщения */
.message-text {
	margin: 0 0 0 0;
	color: rgba(0, 0, 0, 0.7);
	font-family: 'Poppins', sans-serif;
	font-size: 15px;
	font-weight: 500;
	line-height: 1.5;
	word-wrap: break-word;
}

/* Метаданные сообщения */
.message-meta {
	display: flex;
	align-items: center;
	gap: 6px;
	justify-content: flex-end;
}

.message-time {
	color: rgba(255, 255, 255);
	font-family: 'Poppins', sans-serif;
	font-size: 11px;
	letter-spacing: 0.5px;
}

.message-teacher .message-time {
	display: block;
	text-align: right;
	margin-top: 3px;
}

/* Статус прочтения */
.message-status {
	display: flex;
	align-items: center;
}

.status-icon {
	width: 21px;
	height: 11px;
	color: rgba(255, 255, 255, 0.9);
}

.message-status-sent .status-icon {
	color: rgba(255, 255, 255, 0.6);
}

/* Поле ввода */
.chat-input-wrapper_sms {
	flex-shrink: 0;
	padding: 10px 15px;
	background: transparent;
	display: flex;
	align-items: center;
	gap: 12px; /* расстояние между полем ввода и кнопкой */
}

.chat-input {
	flex: 1;
	background: white;
	border-radius: 14px 14px 4px 14px;
	padding: 10px 20px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
	transition: box-shadow 0.3s ease;
}

.chat-input:focus-within {
	box-shadow: 0 4px 12px rgba(65, 139, 152, 0.2);
}

.chat-input-field {
	width: 100%;
	border: none;
	outline: none;
	background: transparent;
	color: rgba(0, 0, 0, 0.8);
	font-family: 'Poppins', sans-serif;
	font-size: 12px;
	font-weight: 500;
}

.chat-input-field::placeholder {
	color: rgba(0, 0, 0, 0.4);
}

.send-button {
	width: 44px;
	height: 44px;
	border: none;
	border-radius: 50%;
	background: white;
	color: rgba(157, 204, 255);
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: all 0.1s ease;
	flex-shrink: 0; /* кнопка не сжимается */
	box-shadow: 0 2px 8px rgba(65, 139, 152, 0.3);
}

.send-button:hover {
	background: #2f929e80;
	box-shadow: 0 4px 12px rgba(65, 139, 152, 0.4);
}

.send-button:active {
	transform: scale(0.95);
}

/* Отключенное состояние кнопки (если поле пустое) */
.send-button:disabled {
	background: #cccccc;
	cursor: not-allowed;
	opacity: 0.6;
}

.send-button:disabled:hover {
	transform: none;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>
